import React, { useState, useLayoutEffect } from 'react';
import { Box, Typography, Grid, makeStyles, useTheme } from '@material-ui/core';
import { styleBreakMobile, styleBreakDesktop } from '../utilities/layouts/Globals';
import PointerRight from '../../resources/images/pointer-right.svg';
import PointerLeft from '../../resources/images/pointer-left.svg';
import PointerFolded from '../../resources/images/pointer-folded.svg';
import { COLOR_WHITE } from '../utilities/MaterialWatchman';
import { TUTORIAL_TYPE } from '../tutorials/TutorialWelcomePage';

const useStyles = makeStyles(theme => ({
    container: {
        [styleBreakMobile(theme)]: {
            width: '100%',
            maxWidth: theme.spacing(38),
        },
        [styleBreakDesktop(theme)]: {
            paddingTop: theme.spacing(1.5),
        },
    },
    complexGrid: {
        marginBottom: theme.spacing(12),
        '& .MuiGrid-item': {
            padding: theme.spacing(0.5),
        },
        [styleBreakDesktop(theme)]: {
            height: theme.spacing(27),
        },
    },
    icon: {
        width: theme.spacing(26.75),
        height: theme.spacing(26.75),
        '& circle.circleClass': {
            fill: COLOR_WHITE,
        },
        [styleBreakMobile(theme)]: {
            width: theme.spacing(20),
            height: theme.spacing(20),
        },
    },
    noIconArea: {
        width: '100%',
        maxWidth: theme.spacing(36),
        [styleBreakDesktop(theme)]: {
            marginTop: theme.spacing(7.5),
        },
        [styleBreakMobile(theme)]: {
            marginLeft: theme.spacing(3),
        },
    },
    subtitleGrid: {
        height: theme.spacing(2.25),
        fontWeight: theme.spacing(75),
        marginBottom: theme.spacing(1),
    },
}));

export default function TutorialFloatingGrid({ tutorialCurrentPage, complexGridInfo, isMobile, type, xCord }) {
    const classes = useStyles();
    const theme = useTheme();
    const [right, setRight] = useState(true);
    const [onboardingTutorialMobileCase1, setOnboardingTutorialMobileCase1] = useState(false);
    const [onboardingTutorialMobileCase2, setOnboardingTutorialMobileCase2] = useState(false);
    const [onboardingTutorialCase3, setOnboardingTutorialCase3] = useState(false);
    const [calendarTutorialCase1, setCalendarTutorialCase1] = useState(false);

    useLayoutEffect(() => {
        type === TUTORIAL_TYPE.ONBOARDING &&
            (!isMobile
                ? [2, 4, 5, 6].includes(tutorialCurrentPage)
                    ? setRight(true)
                    : setRight(false)
                : [3, 4, 5, 6].includes(tutorialCurrentPage)
                ? setRight(true)
                : setRight(false));
        type === TUTORIAL_TYPE.ONBOARDING && (isMobile && !right ? setOnboardingTutorialMobileCase1(true) : setOnboardingTutorialMobileCase1(false));
        type === TUTORIAL_TYPE.ONBOARDING && [4, 5, 6].includes(tutorialCurrentPage)
            ? setOnboardingTutorialMobileCase2(true)
            : setOnboardingTutorialMobileCase2(false);
        type === TUTORIAL_TYPE.ONBOARDING && !isMobile && tutorialCurrentPage === 3 ? setOnboardingTutorialCase3(true) : setOnboardingTutorialCase3(false);
        type === TUTORIAL_TYPE.CALENDAR && (isMobile || [2, 7, 8, 9].includes(tutorialCurrentPage) ? setRight(true) : setRight(false));
        type === TUTORIAL_TYPE.CALENDAR && tutorialCurrentPage > 6 ? setCalendarTutorialCase1(true) : setCalendarTutorialCase1(false);
    }, [isMobile, type, tutorialCurrentPage, right]);

    const styles = {
        containerStyle: {
            position: (onboardingTutorialMobileCase2 || onboardingTutorialCase3 || calendarTutorialCase1) && 'absolute',
            left: (onboardingTutorialMobileCase2 || calendarTutorialCase1) && xCord,
            right: onboardingTutorialCase3 && 0,
            bottom: onboardingTutorialCase3 && theme.spacing(3),
            overflow: onboardingTutorialCase3 && 'hidden',
            paddingLeft:
                type === TUTORIAL_TYPE.ONBOARDING
                    ? [4, 5, 6].includes(tutorialCurrentPage)
                        ? 0
                        : complexGridInfo[tutorialCurrentPage].lPadding
                    : tutorialCurrentPage <= 6
                    ? complexGridInfo[tutorialCurrentPage].lPadding
                    : 0,
        },
        iconStyle: {
            position: onboardingTutorialMobileCase1 && 'absolute',
            right: 0,
        },
        noIconAreaStyle: {
            textAlign: right ? 'left' : 'right',
            position: onboardingTutorialMobileCase1 && 'absolute',
            right: 0,
            marginTop: onboardingTutorialMobileCase1 && theme.spacing(22),
            paddingRight: onboardingTutorialMobileCase1 && theme.spacing(3),
        },
    };

    return (
        <Box className={classes.container} style={styles.containerStyle}>
            <Grid className={classes.complexGrid} container spacing={2}>
                {right && (
                    <Grid item>
                        <img src={PointerRight} alt="pointer-right" className={classes.icon} />
                    </Grid>
                )}
                <Grid item className={classes.noIconArea} style={styles.noIconAreaStyle}>
                    <Typography className={classes.subtitleGrid}>{complexGridInfo[tutorialCurrentPage].title}</Typography>
                    <Typography variant="body1">{complexGridInfo[tutorialCurrentPage].body}</Typography>
                </Grid>
                {!right && (
                    <Grid item>
                        {(type === TUTORIAL_TYPE.CALENDAR && tutorialCurrentPage !== 6) || (type === TUTORIAL_TYPE.ONBOARDING && tutorialCurrentPage !== 3) ? (
                            <img src={PointerLeft} alt="pointer-left" className={classes.icon} style={styles.iconStyle} />
                        ) : (
                            <img src={PointerFolded} alt="pointer-folded" className={classes.icon} />
                        )}
                    </Grid>
                )}
            </Grid>
        </Box>
    );
}
